module.exports = __webpack_public_path__ + "media/svg-new/avatar-1-4dfd930a.svg";